import { render, staticRenderFns } from "./NotificationChannels.vue?vue&type=template&id=d9045854&scoped=true&"
import script from "./NotificationChannels.vue?vue&type=script&lang=js&"
export * from "./NotificationChannels.vue?vue&type=script&lang=js&"
import style0 from "./NotificationChannels.vue?vue&type=style&index=0&id=d9045854&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9045854",
  null
  
)

export default component.exports